
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.4 21.6c0-.44-.36-.8-.8-.8h-.8v-1.6H12c.88 0 1.6-.72 1.6-1.6v-8c0-.88-.72-1.6-1.6-1.6H4c-.88 0-1.6.72-1.6 1.6v8c0 .88.72 1.6 1.6 1.6h3.2v1.6h-.8c-.44 0-.8.36-.8.8H0v1.6h5.6c0 .44.36.8.8.8h3.2c.44 0 .8-.36.8-.8H16v-1.6h-5.6zm-6.4-4v-8h8v8H4zm6.832-2.304L9.128 13.6l1.696-1.704-1.128-1.128L8 12.472l-1.696-1.704-1.128 1.128L6.872 13.6l-1.696 1.704 1.128 1.128L8 14.728l1.696 1.704 1.136-1.136z","fill":"#37474F"}}),_c('path',{attrs:{"d":"M16.667 8.667h-1.334v-4h1.334v4zm0 2.666h-1.334V10h1.334v1.333zm-.667-10A6.67 6.67 0 009.334 8 6.67 6.67 0 0016 14.667 6.67 6.67 0 0022.667 8 6.669 6.669 0 0016 1.333z","fill":"#D32F2F"}})])
          )
        }
      }
    